import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c35ba444"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topban" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zhengque" }, "治疗方案公布")
], -1))
const _hoisted_3 = { class: "ding" }
const _hoisted_4 = { class: "dingimg" }
const _hoisted_5 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "6.1333rem",
              height: "5.4267rem",
              src: require('../assets/wenzi.png')
            }, null, 8, ["src"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_image, {
            onClick: $options.gongbu,
            width: "5.32rem",
            height: "1.1467rem",
            src: require('../assets/chakanxiaoguo.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}